<script setup lang="ts">
    import AppText from '@/components/AppText.vue';
    import { useApprovePlanViewModel } from '@/views/3d-planner/components/useApprovePlanViewModel';
    import { PLANNER_TARGETS } from '@/domain/analytics/analyticsTargets';

    const props = withDefaults(
        defineProps<{
            valid?: boolean;
        }>(),
        {
            valid: true,
        },
    );

    // Destructured so the template binds the values rather than the refs: a plain composable
    // returns raw refs, which Vue does not auto-unwrap through an object, but does unwrap as
    // top-level bindings of `<script setup>`.
    const { label, isSaving, buttonDisabled, tooltip, showChangesHint, proposalHint, submit } =
        useApprovePlanViewModel(() => props.valid);
</script>

<template>
    <div class="approve-plan pb-0 mt-4">
        <app-button-cta
            class="approve-btn"
            :data-analytics-id="PLANNER_TARGETS.generatePlanButton"
            prepend-icon="mdi-check"
            :loading="isSaving"
            :disabled="buttonDisabled"
            @click="submit"
        >
            {{ label }}
        </app-button-cta>
        <app-tooltip v-if="tooltip" activator="parent" location="top">
            <span>{{ tooltip }}</span>
        </app-tooltip>
        <app-hint v-if="showChangesHint" class="pt-2 d-flex justify-start">
            <app-text inline>Changes have been made since plan creation.</app-text>
            <app-tooltip max-width="450" activator="parent" location="bottom" open-on-hover>
                <v-container outline class="rounded-sm pa-0 ma-0">
                    <p class="font-weight-bold">
                        Changes have been made since the latest plan was created
                    </p>
                    <p>
                        If you wish these changes to be represented in the downloadable manual Plan
                        for this Case, click the button once you&rsquo;re happy with your changes.
                    </p>
                </v-container>
            </app-tooltip>
        </app-hint>
        <app-hint v-else-if="proposalHint" class="pt-2 d-flex justify-start">
            <app-text inline>{{ proposalHint }}</app-text>
        </app-hint>
    </div>
</template>

<style scoped lang="scss">
    .approve-btn {
        width: 323px !important;
    }

    .approve-plan {
        text-align: center;
    }
</style>
